export default __webpack_public_path__ + "images/weekly-schedule/form-error-93bd85d7c15d1f12d2b019c1f58760e6.svg";